"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonFill = exports.RowPix = exports.QRCode = exports.TypeBox = exports.FormItemFormulary = exports.RadioStyled = exports.CheckboxStyled = exports.InputStyled = exports.SelectStyled = exports.MaskInputStyled = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const antd_mask_input_1 = __importDefault(require("antd-mask-input"));
const antd_1 = require("antd");
const constants_1 = require("../../assets/constants/constants");
const ButtonPrimary_1 = __importDefault(require("../shared/ButtonPrimary"));
exports.MaskInputStyled = (0, styled_components_1.default)(antd_mask_input_1.default) `
  border-radius: 5px;
  height: 43px;
`;
exports.SelectStyled = (0, styled_components_1.default)(antd_1.Select) `
  .ant-select-selector {
    border-radius: 5px !important;
    height: 43px !important;
  }
`;
exports.InputStyled = (0, styled_components_1.default)(antd_1.Input) `
  border-radius: 5px;
  height: 43px;

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }
`;
exports.CheckboxStyled = (0, styled_components_1.default)(antd_1.Checkbox) `
  span {
    width: 20px;
    height: 20px;
  }
`;
exports.RadioStyled = (0, styled_components_1.default)(antd_1.Radio) `
  padding: 10px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.19);
  -webkit-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.19);
  margin-right: 25px;

  @media screen and (max-width: 992px) {
    flex: 1;
    width: 100%;
    margin-bottom: 10px;
  }
`;
exports.FormItemFormulary = (0, styled_components_1.default)(antd_1.Form.Item) `
  label {
    color: #000;
    font-weight: 500;
  }
  .ant-select-selection-item {
    height: 43px;
  }
  .ant-select-selector {
    height: 43px;
  }
`;
exports.TypeBox = (0, styled_components_1.default)(antd_1.Col) `
  #Pix,
  #Credit {
    display: none;
  }

  ${props => {
    switch (props.display) {
        case constants_1.PAYMENT_TYPE.CREDIT:
            return (0, styled_components_1.css) `
          #Credit {
            display: flex;
          }
          #Pix {
            display: none;
          }
          #Debit {
            display: none;
          }
        `;
        case constants_1.PAYMENT_TYPE.DEBIT:
            return (0, styled_components_1.css) `
          #Credit {
            display: none;
          }
          #Pix {
            display: none;
          }
          #Debit {
            display: flex;
          }
        `;
        case constants_1.PAYMENT_TYPE.PIX:
            return (0, styled_components_1.css) `
          #Credit {
            display: none;
          }
          #Pix {
            display: flex;
          }
          #Debit {
            display: none;
          }
        `;
        default:
            (0, styled_components_1.css) `
          #Credit {
            display: none;
          }
          #Pix {
            display: none;
          }
          #Debit {
            display: none;
          }
        `;
    }
}}

  ${props => props.display === constants_1.PAYMENT_TYPE.CREDIT &&
    (0, styled_components_1.css) `
      #Credit {
        display: flex;
      }
      #Pix {
        display: none;
      }
    `}

  ${props => props.display === 'pix' &&
    (0, styled_components_1.css) `
      #Credit {
        display: none;
      }
      #Pix {
        display: flex;
      }
    `}
`;
exports.QRCode = styled_components_1.default.div `
  width: 110px;
  height: 110px;
  border: 1px solid gray;
`;
exports.RowPix = (0, styled_components_1.default)(antd_1.Row) `
  padding-top: 25px;
  counter-reset: section;
  .ant-typography::before {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    width: 25px;
    height: 25px;
    color: #fff;
    margin: 0;
    border-radius: 50%;
    background-color: #c31c4a;
    counter-increment: section;
    content: counter(section);
    margin-right: 5px;
  }
`;
exports.ButtonFill = (0, styled_components_1.default)(ButtonPrimary_1.default) `
  border-radius: 5px;

  width: auto !important;
  margin-bottom: 25px;
  text-align: center !important;

  @media (max-width: ${constants_1.SCREEN_WIDTH.mobile}px) {
    width: 100% !important;
  }
`;
